<app-view-title Title="Details" [isPrimaryColor]="true"></app-view-title>
<div class="area">
  <div style="z-index:1;position: relative; margin:0px 30px 30px 30px; padding: 15px; box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, .2), 0px 1px 1px 0px rgba(0, 0, 0, .14), 0px 1px 3px 0px rgba(0, 0, 0, .12); background-color: white; border-radius:25px;">
    <div *ngIf="!isLoading">
      <div style="text-align:center">
        <p style="margin-top:5px; font-weight:bold; font-size:16px;">
          <span style="color:black; font-size:18px;">{{campaign.Title}}</span>
        </p>
        <mat-divider style="margin: 5px auto 5px auto; width: 80%;"></mat-divider>
        <p style="white-space:pre-wrap; color:black;">
          <ng-container *ngIf="qrcodeUri != ''">
            {{'Intellitrailer.MyPage.CampaignCardDetails.txt' | translate:'Kindly show this QR code to the staff at the register.'}}
          </ng-container>
          <ng-container *ngIf="qrcodeUri == ''">
            {{'Intellitrailer.MyPage.CampaignCardDetails.txtNoQR' | translate:'Kindly show this to the staff at the register.'}}
          </ng-container>
        </p>
        <mat-divider style="margin:5px auto 5px auto; width:60%;"></mat-divider>
        <ng-container *ngIf="qrcodeUri != ''">
          <img [src]="qrcodeUri" style="width:100%;">
        </ng-container>
        <ng-container *ngIf="qrcodeUri == ''">
          <p style="white-space:pre-wrap; color:black;">
            <span *ngIf="campaign.Comment && campaign.Comment.trim() !== ''"> {{campaign.Comment}}</span>
          </p>
          <img [src]="campaign.Image.Uri" style="width:200px; height:200px;" />
        </ng-container>
      </div>
      <p style="color:black; text-align:center;">Activated: {{activatedAt | date: 'MMM d, hh:mm' | transliterate }}</p>
    </div>
    <div *ngIf="isLoading">
      <mat-spinner style="margin:auto;"></mat-spinner>
    </div>
  </div>

  <!--For the Animated Background.-->
  <ul class="circles">
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
  </ul>
</div>
